import * as _ from 'lodash';
import { CognitoIdentityServiceProvider } from 'aws-sdk';

export class PasswordPolicy {
  cognitoPolicy: CognitoIdentityServiceProvider.PasswordPolicyType;

  constructor(policy: CognitoIdentityServiceProvider.PasswordPolicyType) {
    this.cognitoPolicy = policy;
  }

  validateAgainstCognitoPolicy(password: string): string {
    const failures = [];

    if (password.length < this.cognitoPolicy.MinimumLength) {
      failures.push(`at least ${this.cognitoPolicy.MinimumLength} characters`);
    }
    if (this.cognitoPolicy.RequireUppercase && !/[A-Z]/.test(password)) {
      failures.push(`an uppercase character`);
    }
    if (this.cognitoPolicy.RequireLowercase && !/[a-z]/.test(password)) {
      failures.push(`a lowercase character`);
    }
    if (this.cognitoPolicy.RequireNumbers && !/\d/.test(password)) {
      failures.push(`a number`);
    }
    if (this.cognitoPolicy.RequireSymbols && !/[^A-Za-z\d]/.test(password)) {
      failures.push(`a symbol`);
    }

    if (failures.length === 0) {
      return '';
    } else {
      const count = failures.length;
      const failureMsg = _.map(failures, (msg, index) => {
        return index === 0
          ? msg
          : index === count - 1
            ? `, or ${msg}`
            : `, ${msg}`;
      });
      return `Your password does not contain ${failureMsg.join('')}.`;
    }
  }

  displayCognitoPolicy(): string {
    const minLength = `Your organization requires a minimum length of ${
      this.cognitoPolicy.MinimumLength
    } characters`;
    if (
      this.cognitoPolicy.RequireUppercase ||
      this.cognitoPolicy.RequireLowercase ||
      this.cognitoPolicy.RequireNumbers ||
      this.cognitoPolicy.RequireSymbols
    ) {
      let types = '';
      types += this.cognitoPolicy.RequireUppercase
        ? `${types.length ? ',' : ''} uppercase letters`
        : '';
      types += this.cognitoPolicy.RequireUppercase
        ? `${types.length ? ',' : ''} lowercase letters`
        : '';
      types += this.cognitoPolicy.RequireUppercase
        ? `${types.length ? ',' : ''} numbers`
        : '';
      types += this.cognitoPolicy.RequireUppercase
        ? `${types.length ? ',' : ''} symbols`
        : '';
      return `${minLength} and at least one of each of the following:${types}.`;
    } else {
      return `${minLength}.`;
    }
  }
}
